@if (isV2()) {
	<div class="assignee-v2">
		<header class="assignee-v2-header">
			<div class="assignee-v2-titles">
				<h2 class="assignee-v2-title">{{ "ASSIGNEE_PICKER__TITLE" | transloco }}</h2>
				<p class="assignee-v2-description">{{ "ASSIGNEE_PICKER__DESCRIPTION" | transloco }}</p>
			</div>
			<button
				type="button"
				class="assignee-v2-close"
				(click)="close()"
				[attr.aria-label]="'ASSIGNMENT__BUTTON_CANCEL' | transloco"
			>
				<span class="material-symbols-outlined" aria-hidden="true">close</span>
			</button>
		</header>

		<div class="assignee-v2-toolbar">
			<ion-searchbar
				mode="ios"
				[placeholder]="'SEARCH_FIELD__PLACEHOLDER' | transloco"
				(ionInput)="onSearchChange($event)"
			></ion-searchbar>

			@if (assignees.length > 0) {
				<div class="assignee-v2-selected">
					@for (assignee of assignees; track assignee.id) {
						<button type="button" class="assignee-v2-chip" (click)="removeAssignee(assignee)">
							<span class="material-symbols-outlined" aria-hidden="true">
								{{ assignee.id.startsWith("usergroups/") ? "group" : "person" }}
							</span>
							{{ assignee.name }}
							<span class="material-symbols-outlined" aria-hidden="true">close</span>
						</button>
					}
				</div>
			}

			<div class="assignee-v2-segments" role="tablist">
				<button
					type="button"
					class="assignee-v2-segment"
					[class.assignee-v2-segment--active]="segmentChoice === 'users'"
					(click)="segmentChoice = 'users'"
				>
					{{ "ASSIGNEE_PICKER__USERS" | transloco }}
				</button>
				<button
					type="button"
					class="assignee-v2-segment"
					[class.assignee-v2-segment--active]="segmentChoice === 'usergroups'"
					(click)="segmentChoice = 'usergroups'"
				>
					{{ "ASSIGNEE_PICKER__USER_GROUPS" | transloco }}
				</button>
			</div>
		</div>

		<div class="assignee-v2-body">
			@if (segmentChoice === "users") {
				@for (user of filteredUsers; track user.id) {
					<button
						type="button"
						class="assignee-v2-row"
						[class.assignee-v2-row--selected]="isSelected(user)"
						[disabled]="isSelected(user) || (singleSelect && assignees.length > 0)"
						(click)="selectAssignee(user)"
					>
						<span class="material-symbols-outlined" aria-hidden="true">person</span>
						<span>{{ user.name }}</span>
						@if (isSelected(user)) {
							<span class="material-symbols-outlined assignee-v2-check" aria-hidden="true">check</span>
						}
					</button>
				}
			} @else {
				@for (group of filteredUserGroups; track group.id) {
					<button
						type="button"
						class="assignee-v2-row"
						[class.assignee-v2-row--selected]="isSelected(group)"
						[disabled]="isSelected(group) || (singleSelect && assignees.length > 0)"
						(click)="selectAssignee(group)"
					>
						<span class="material-symbols-outlined" aria-hidden="true">group</span>
						<span>{{ group.name }}</span>
						@if (isSelected(group)) {
							<span class="material-symbols-outlined assignee-v2-check" aria-hidden="true">check</span>
						}
					</button>
				}
			}
		</div>

		<footer class="assignee-v2-footer">
			<button type="button" class="assignee-v2-btn assignee-v2-btn--ghost" (click)="close()">
				{{ "ASSIGNMENT__BUTTON_CANCEL" | transloco }}
			</button>
			<button
				type="button"
				class="assignee-v2-btn assignee-v2-btn--primary"
				(click)="save()"
				[disabled]="assignees.length === 0"
			>
				{{ "ASSIGNMENT__BUTTON_SAVE" | transloco }}
			</button>
		</footer>
	</div>
} @else {
	<ion-header>
		<ion-toolbar>
			<ion-title>{{ "ASSIGNEE_PICKER__TITLE" | transloco }}</ion-title>
			<ion-buttons slot="end">
				<ion-button (click)="close()">
					<ion-icon slot="icon-only" name="close-outline"></ion-icon>
				</ion-button>
			</ion-buttons>
		</ion-toolbar>
		<ion-toolbar>
			<ion-text>
				<p class="ion-padding-start ion-padding-end">
					{{ "ASSIGNEE_PICKER__DESCRIPTION" | transloco }}
				</p>
			</ion-text>
			<ion-searchbar
				mode="ios"
				[placeholder]="'SEARCH_FIELD__PLACEHOLDER' | transloco"
				(ionInput)="onSearchChange($event)"
			></ion-searchbar>

			<div class="assignees">
				<ion-button
					(click)="removeAssignee(assignee)"
					shape="round"
					fill="outline"
					*ngFor="let assignee of assignees"
				>
					{{ assignee.name }}
					<ion-icon
						slot="start"
						name="person-outline"
						size="small"
						*ngIf="assignee.id.startsWith('users/')"
					></ion-icon>
					<ion-icon
						slot="start"
						name="people-outline"
						size="small"
						*ngIf="assignee.id.startsWith('usergroups/')"
					></ion-icon>
					<ion-icon slot="end" name="close"></ion-icon>
				</ion-button>
			</div>

			<ion-segment value="users" [mode]="'md'" [value]="segmentChoice" (ionChange)="toggleChoice($event)">
				<ion-segment-button value="users">
					<ion-label>{{ "ASSIGNEE_PICKER__USERS" | transloco }}</ion-label>
				</ion-segment-button>
				<ion-segment-button value="usergroups">
					<ion-label>{{ "ASSIGNEE_PICKER__USER_GROUPS" | transloco }}</ion-label>
				</ion-segment-button>
			</ion-segment>
		</ion-toolbar>
	</ion-header>

	<ion-content>
		<ion-list *ngIf="segmentChoice === 'users'">
			<ion-item *ngFor="let user of filteredUsers" (click)="selectAssignee(user)">{{ user.name }}</ion-item>
		</ion-list>
		<ion-list *ngIf="segmentChoice === 'usergroups'">
			<ion-item *ngFor="let usergroup of filteredUserGroups" (click)="selectAssignee(usergroup)">
				{{ usergroup.name }}
			</ion-item>
		</ion-list>
	</ion-content>
	<ion-footer>
		<ion-toolbar>
			<div class="button-container">
				<ion-button (click)="close()" shape="round" color="light">
					{{ "ASSIGNMENT__BUTTON_CANCEL" | transloco }}
				</ion-button>
				<ion-button (click)="save()" shape="round" color="primary" [disabled]="assignees.length === 0">
					{{ "ASSIGNMENT__BUTTON_SAVE" | transloco }}
				</ion-button>
			</div>
		</ion-toolbar>
	</ion-footer>
}
